import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";

const GuestRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default GuestRoute;
